import styled from '@emotion/styled'
import { Box } from '@gousto-internal/citrus-react'

const layouts = {
  5: {
    display: 'grid',
    aspectRatio: '3/2',
    gridTemplateColumns: 'repeat(6, 1fr)',
    '> img:nth-of-type(-n+2)': {
      gridColumn: 'span 3',
    },
    '> img:nth-of-type(n+3)': {
      gridColumn: 'span 2',
    },
  },
  4: {
    display: 'grid',
    aspectRatio: '3/2',
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  3: {
    display: 'grid',
    aspectRatio: '3/2',
    gridTemplateColumns: 'repeat(2, 1fr)',
    '> img:nth-of-type(-n+2)': {
      gridColumn: 'span 1',
    },
    '> img:nth-of-type(3)': {
      gridColumn: 'span 2',
    },
  },
}

type LayoutProps = {
  layout: keyof typeof layouts
}

export const RecipeImageLayout = styled(Box)<LayoutProps>((props) => layouts[props.layout])
